import { Box, Text } from '@chakra-ui/react';
import { Grid, WrappedImage } from '@time-line/components/common';
import {
  RichTextResolver,
  SnugContentContainer,
} from 'components/common/RichTextResolver';
import type { ListicleItem as ListicleItemProps } from 'types/cms/blocks';

export function ListicleItem({ title, description, image }: ListicleItemProps) {
  return (
    <Grid className="section--listicle-item" my="2xl">
      <Grid.Inner gridColumn="main" gridRowGap="m">
        <Box
          gridColumn={{
            base: 'span 12',
            lg: 'span 5',
          }}
        >
          {image && (
            <WrappedImage
              image={image}
              ratio={3 / 2}
              sizes="(min-width: 960px) 40vw, (min-width: 1920px) 1800px, 90vw"
            />
          )}
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          gridColumn={{
            base: 'span 12',
            lg: '7 / 12',
          }}
        >
          <Text as="h2" size="h3">
            {title}
          </Text>
          <Box color="blackAlpha.700" mt="2xs">
            <RichTextResolver
              blocks={description}
              container={SnugContentContainer}
            />
          </Box>
        </Box>
      </Grid.Inner>
    </Grid>
  );
}
